var $8c59fd0c2c96821b$exports = {};
$8c59fd0c2c96821b$exports = {
  "Clear search": "Vymazat hled\xE1n\xED"
};
export { $8c59fd0c2c96821b$exports as default };